'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-4474431a.js');
const _package = require('./package-2c27a669.js');
const SearchModalUploadIcon = require('./SearchModalUploadIcon-b6db8026.js');
const constants = require('./constants-7684cbfc.js');

const SearchModalCameraIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 4H20C22.21 4 24 5.79 24 8V16H22V8C22 6.9 21.1 6 20 6H16.93L16.34 5.11L14.93 3H9.07L7.66 5.11L7.07 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H9V22H4C1.79 22 0 20.21 0 18V8C0 5.79 1.79 4 4 4H6L8 1H16L18 4ZM12 8C14.76 8 17 10.24 17 13L16.99 13.01C16.99 14.02 16.68 14.97 16.16 15.76L20.7 20.3L19.29 21.71L14.75 17.17C13.96 17.69 13.02 18 12 18C9.24 18 7 15.76 7 13C7 10.24 9.24 8 12 8ZM9 13C9 14.65 10.35 16 12 16C13.65 16 15 14.65 15 13C15 11.35 13.65 10 12 10C10.35 10 9 11.35 9 13Z", fill: "#161616" })));

const SearchModalFullSearchIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M4 8C4 5.79 5.79 4 8 4H9V2H8C4.69 2 2 4.69 2 8V9H4V8Z", fill: "#161616" }),
  index.h("path", { d: "M20 8C20 5.79 18.21 4 16 4H15V2H16C19.31 2 22 4.69 22 8V9H20V8Z", fill: "#161616" }),
  index.h("path", { d: "M4 16V15H2V16C2 19.31 4.69 22 8 22H9V20H8C5.79 20 4 18.21 4 16Z", fill: "#161616" }),
  index.h("path", { d: "M17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.02 17 13.96 16.69 14.75 16.17L19.29 20.71L20.7 19.3L16.16 14.76C16.68 13.97 16.99 13.02 16.99 12.01L17 12ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15Z", fill: "#161616" })));

const SearchModalImageSearchIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M4 8C4 5.79 5.79 4 8 4H9V2H8C4.69 2 2 4.69 2 8V9H4V8Z", fill: "#161616" }),
  index.h("path", { d: "M4 16V15H2V16C2 19.31 4.69 22 8 22H9V20H8C5.79 20 4 18.21 4 16Z", fill: "#161616" }),
  index.h("path", { d: "M20 16C20 18.21 18.21 20 16 20H15V22H16C19.31 22 22 19.31 22 16V15H20V16Z", fill: "#161616" }),
  index.h("path", { d: "M16 2H15V4H16C18.21 4 20 5.79 20 8V9H22V8C22 4.69 19.31 2 16 2Z", fill: "#161616" }),
  index.h("path", { d: "M17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15Z", fill: "#161616" })));

const vviinnVpsButtonCss = ":host{display:block;line-height:0}";

const VviinnVpsButton = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.vviinnWidgetLoad = index.createEvent(this, "vviinnWidgetLoad", 7);
    this.vviinnWidgetOpen = index.createEvent(this, "vviinnWidgetOpen", 7);
    this.vviinnWidgetClose = index.createEvent(this, "vviinnWidgetClose", 7);
    this.vviinnImageUpload = index.createEvent(this, "vviinnImageUpload", 7);
    this.vviinnProductLoad = index.createEvent(this, "vviinnProductLoad", 7);
    this.vviinnProductClick = index.createEvent(this, "vviinnProductClick", 7);
    this.vviinnProductView = index.createEvent(this, "vviinnProductView", 7);
    this.vviinnResultLoad = index.createEvent(this, "vviinnResultLoad", 7);
    this.vviinnResultView = index.createEvent(this, "vviinnResultView", 7);
    this.vviinnNoResult = index.createEvent(this, "vviinnNoResult", 7);
    this.vviinnImageCrop = index.createEvent(this, "vviinnImageCrop", 7);
    this.vviinnSelectObject = index.createEvent(this, "vviinnSelectObject", 7);
    this.vviinnSelectFilter = index.createEvent(this, "vviinnSelectFilter", 7);
    this.globalSlotsChanged = index.createEvent(this, "globalSlotsChanged", 7);
    this.getBasicEventData = () => {
      return {
        widgetType: "VPS",
        campaignTypeId: "VPS",
        campaignTypeName: _package.campaignTypeNames["VPS"],
        widgetId: this.el.id,
        widgetVersion: _package.version,
      };
    };
    this.token = undefined;
    this.currencySign = "€";
    this.locale = "de-DE";
    this.campaignId = "";
    this.addStyle = false;
    this.mode = "modal";
    this.excluded = "";
    this.productDetailsNewTab = true;
    this.productDetailsRedirect = true;
    this.imageResolutionWidth = 250;
    this.exampleImageSource = constants.DEFAULT_EXAMPLE_IMAGE;
    this.textSearchShow = false;
    this.addToBasketShow = false;
    this.favoriteShow = false;
    this.showOneClickDiscovery = false;
    this.addPriceContainer = false;
    this.apiPath = undefined;
    this.buttonPressed = false;
  }
  handleModalClosed() {
    this.buttonPressed = false;
  }
  componentDidLoad() {
    this.replaceSlotsContent();
  }
  replaceSlotsContent() {
    const slots = this.el.querySelectorAll("[slot]");
    this.globalSlotsChanged.emit({
      slots: Array.from(slots),
      element: this.el,
    });
  }
  handleClick() {
    this.buttonPressed = true;
  }
  resetButton() {
    this.buttonPressed = false;
  }
  render() {
    return (index.h(index.Host, { tabindex: "0", role: "button" }, index.h("vviinn-button", { onClick: () => {
        this.handleClick();
      }, addStyle: this.addStyle, part: "vviinn-button" }, index.h("slot", null, this.mode === "camera" ? (index.h(SearchModalCameraIcon, null)) : this.mode === "upload" ? (index.h(SearchModalUploadIcon.SearchModalUploadIcon, null)) : this.textSearchShow ? (index.h(SearchModalFullSearchIcon, null)) : (index.h(SearchModalImageSearchIcon, null)))), _package.SlotSkeleton("vps"), index.h("vviinn-vps-widget", { mode: this.mode, "currency-sign": this.currencySign, token: this.token, locale: this.locale, apiPath: this.apiPath, campaignId: this.campaignId, showingInButton: true, buttonPressed: this.buttonPressed, resetVpsButton: this.resetButton.bind(this), buttonElementId: this.el.id, active: this.buttonPressed &&
        (this.mode === "modal" || this.mode === "camera"), excluded: this.excluded, productDetailsNewTab: this.productDetailsNewTab, productDetailsRedirect: this.productDetailsRedirect, imageResolutionWidth: this.imageResolutionWidth, exampleImageSource: this.exampleImageSource, textSearchShow: this.textSearchShow, addToBasketShow: this.addToBasketShow, addPriceContainer: this.addPriceContainer, replaceSlotsContentInButton: this.replaceSlotsContent.bind(this), showOneClickDiscovery: this.showOneClickDiscovery, favoriteShow: this.favoriteShow })));
  }
  get el() { return index.getElement(this); }
};
VviinnVpsButton.style = vviinnVpsButtonCss;

exports.vviinn_vps_button = VviinnVpsButton;
